import { getCurrentProduct } from 'utils/productCookies';
import styles from './styles.module.scss';

function Disclaimer() : JSX.Element {
  const currentProduct = getCurrentProduct();

  if(currentProduct !== 'plannexo')
    return <></>;

  return (
    <p id={styles['biobar-disclaimer']}>
      Caso queira visualizar informações de outro Grupo é necessário selecionar um dos seus estabelecimentos na lista acima.
    </p>
  );
}

export default Disclaimer;